import instance from ".";
import { API_ENDPOINTS } from "../utils/constants";

export const signup = async (userInfo) => {
  const response = await instance.post(API_ENDPOINTS.user.signup, userInfo);
  return response?.data;
};

export const verify = async (userId) => {
  const response = await instance.post(API_ENDPOINTS.user.verify, { userId });
  return response?.data;
};

export const login = async (userId, password) => {
  const response = await instance.post(API_ENDPOINTS.user.login, {
    userId,
    password,
  });
  return response?.data;
};

export const refresh = async (refreshToken) => {
  const response = await instance.post(API_ENDPOINTS.user.refresh, {
    refreshToken,
  });
  return response?.data;
};

export const getProfile = async () => {
  const response = await instance.get(API_ENDPOINTS.user.profile);
  return response?.data;
};

export const deleteAccount = async () => {
  const response = await instance.post(API_ENDPOINTS.user.delete);
  return response.data;
};

export const updateUser = async (userInfo) => {
  const response = await instance.post(API_ENDPOINTS.user.update, userInfo);
  return response?.data;
};

export const resetPassword = async ({ password, newPassword }) => {
  const response = await instance.post(API_ENDPOINTS.user.resetPassword, {
    password,
    newPassword,
  });
  return response?.data;
};

export const resetPhone = async ({ phoneNumber, logId }) => {
  const response = await instance.post(API_ENDPOINTS.user.resetPhone, {
    phoneNumber,
    logId,
  });
  return response?.data;
};

export const findPassword = async ({
  userId,
  phoneNumber,
  password,
  logId,
}) => {
  const response = await instance.post(API_ENDPOINTS.user.findPassword, {
    userId,
    phoneNumber,
    password,
    logId,
  });
  return response?.data;
};

export const findAccount = async ({ phoneNumber, logId }) => {
  const response = await instance.post(API_ENDPOINTS.user.findAccount, {
    phoneNumber,
    logId,
  });
  return response?.data;
};

export const updateAutoLogin = async (autoLogin) => {
  return await instance.put(API_ENDPOINTS.user.updateAutoLogin, {
    autoLogin,
  });
};
